/** Публичные страницы control-plane — без проверки тенанта по Host. */
export function isPublicRegistrationPath(pathname: string): boolean {
  return (
    pathname === '/register' ||
    pathname === '/dealer/onboarding' ||
    pathname.startsWith('/register/') ||
    pathname.startsWith('/dealer/onboarding/')
  )
}

/** Страницы, которым не нужна сессия (публичная регистрация control-plane). */
export function isSessionOptionalPath(pathname: string): boolean {
  return isPublicRegistrationPath(pathname)
}
